import { getWeekStart } from '@utils/dates'
import { DateTime, Interval } from 'luxon'

const getLastDayOfLastWeekOfMonth = (
  lastDayOfMonth: DateTime,
  weekStart: 'monday' | 'sunday',
): DateTime => {
  const endDayOfWeek = weekStart === 'sunday' ? 6 : 7 // Saturday for Sunday start, Sunday for Monday start
  let endOfLastWeek = lastDayOfMonth

  // Keep adding days until we reach the end of the week
  while (endOfLastWeek.weekday !== endDayOfWeek) {
    endOfLastWeek = endOfLastWeek.plus({ days: 1 })
  }

  return endOfLastWeek
}

export const generateCalendar = (
  fromDateTime: DateTime,
  weekStart: 'monday' | 'sunday' = 'sunday',
): Array<Array<DateTime>> => {
  const firstDayOfMonth = fromDateTime.startOf('month')

  // For calendar display, we always want to show complete weeks
  // If the month starts on Sunday and we want Sunday week start, we need to go back to show the previous week
  const startOfFirstWeek = getWeekStart(firstDayOfMonth, weekStart)

  const lastDayOfMonth = fromDateTime.endOf('month')

  const lastDayOfLastWeekOfMonth = getLastDayOfLastWeekOfMonth(
    lastDayOfMonth,
    weekStart,
  )

  return Interval.fromDateTimes(startOfFirstWeek, lastDayOfLastWeekOfMonth)
    .splitBy({ week: 1 })
    .map((week) =>
      week.splitBy({ day: 1 }).map((dayInterval) => dayInterval.start),
    )
}
